import * as env from 'config/environment';
import React, { useState } from 'react';
import { getUserStorage } from 'components/features/utils/utils';
import { isApp, isIosApp } from 'components/features/utils/userStatus';
import LoginSideMenu from './components/LoginSideMenu';
import { HeadBlock } from './components/HeadBlock';

export const fromLpToNoticeURL = 'notificationList/2/1/1';

const TemporaryLogin: React.FC = () => {
  const [isShowSideMenu, setIsShowSideMenu] = useState(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const menuShow = (): void => {
    setIsShowSideMenu(true);
    setHideAnimate(false);
  };
  const menuHide = (): void => {
    setIsShowSideMenu(false);
  };
  const menuHideAnimate = (): void => {
    setHideAnimate(true);
  };

  const goBack = () => {
    window.history.back();
  };

  const linkGuest = `${env.registerURL}?utm_source=tw_minkabu&utm_medium=temporarylogin&utm_campaign=guest_asset_202410&service=TradeWell&callback_url=${env.appURL}/auth`;
  const linkNotPremium = `${env.premiumURL}?utm_source=tw_minkabu&utm_medium=temporarylogin&utm_campaign=free_asset_202410&service=TradeWell&callback_url=${env.appURL}/auth`;
  const linkPremium = `${env.appURL}/auth`;

  const userStorage = getUserStorage();
  const userType =
    userStorage === null
      ? 'guest'
      : userStorage.Charged
      ? 'premium'
      : 'not_premium';

  const login = () => {
    const link =
      userType === 'guest'
        ? linkGuest
        : userType === 'premium'
        ? linkPremium
        : linkNotPremium;
    window.location.href = link;
  };

  const minkabuLogin = (): void => {
    window.location.href = 'https://id.minkabu.jp/login';
  };

  return (
    <>
      <HeadBlock {...{ noindex: true }} />
      {/* ヘッダー */}
      <header className="bg-white z-50 shadow-md sticky top-0" id="id_header">
        <div className="ui-header-sp border-b border-gray-300">
          <nav className="flex p-2">
            <div
              className="flex-1 flex justify-start"
              onClick={(): void => goBack()}>
              <button className="flex items-center p-2">
                <i className="icon-chevron-left text-2xl text-bluegray-500"></i>
                <span className="text-gray-800">戻る</span>
              </button>
            </div>
            <div className="flex-grow flex justify-center items-center">
              <a title="みんかぶ" href="https://minkabu.jp/">
                <img
                  src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                  width="110"
                  height="30"
                  alt="みんかぶ"
                />
              </a>
            </div>
            <div className="flex-1 flex justify-end">
              <section className="pl-4 pr-2 pt-2">
                {!isApp && (
                  <div
                    className={`btn-trigger ${isShowSideMenu ? 'active' : ''}`}
                    id="btn01"
                    onClick={!isShowSideMenu ? menuShow : menuHideAnimate}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                )}
              </section>
            </div>
          </nav>
        </div>
      </header>
      {isShowSideMenu && (
        <div className={`fixed left-0 ui-h-screen w-screen z-20`}>
          <LoginSideMenu
            hideAnimate={hideAnimate}
            menuHide={menuHide}
            onNavLinkClick={(e: React.MouseEvent, path: string) => {
              return;
            }}
          />
        </div>
      )}
      {/* コンテンツ */}
      <div className="login relative">
        <div className="w-full bg-slate-800">
          <div className="max-w-272p lg:max-w-442p mx-auto py-3">
            <div className="flex flex-col flex-1 bg-white rounded-md py-6 px-4 h-full shadow-card">
              <div className="text-center text-sm font-bold leading-5">
                資産総額
              </div>
              <div className="flex justify-center items-center leading-6">
                <div className="mr-2 h-4 w-4"></div>
                <div className="font-bold">
                  <span className="text-xl mr-2">0</span>
                  <span className="text-xs">円</span>
                </div>
                <span className="icon-eye_open_img text-bluegray-400 ml-2"></span>
              </div>
              <div className="flex items-center text-xs mt-2 pt-1 px-2 border-t border-bluegray-300">
                <div className="text-gray-700 leading-3.5">評価損益</div>
                <div className="flex ml-auto font-bold">
                  <label className="text-Up">
                    <div className="flex items-center">
                      <div className="text-sm">0</div>
                      <div className="ml-1">円</div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* pc */}
        <div className="lg:flex hidden flex-col max-w-md mx-auto">
          <div className="text-white bg-gray-800 pt-8">
            <div
              className="flex flex-col items-center bg-temporaryLoginChart bg-center"
              style={{
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '0% 0%',
                backgroundSize: '100%',
              }}>
              <div className="mt-68 text-26 font-bold text-center">
                株式投資、投資信託を
                <br />
                まとめて管理！
              </div>
              <div className="mb-6 px-4 py-1 text-sm font-bold bg-indigo-450 rounded-full">
                NISA・iDeCo・米国株に対応
              </div>
            </div>
            <div className="flex flex-col items-center px-4 pb-8">
              {userType !== 'premium' ? (
                <div className="app-primary-label-block flex justify-center mt-6 mb-1 text-sm">
                  <div className="inline-flex items-center flex-col">
                    30日間無料でプレミアムを体験
                  </div>
                </div>
              ) : (
                <></>
              )}
              <button
                className={`bg-gradient-r-red w-full flex justify-center py-2 text-lg font-bold max-w-btn-l text-white leading-9 rounded-lg cursor-pointer hover:opacity-75 ${
                  userType !== 'guest' ? '' : ''
                }`}
                onClick={() => login()}>
                {userType === 'premium' ? 'アセプラ' : 'みんかぶ'}
                で資産管理を始める
              </button>
              {userType === 'guest' ? (
                <div
                  className="pt-6 text-sm text-center underline cursor-pointer"
                  onClick={minkabuLogin}>
                  みんかぶ会員の方はこちら
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {/* sp */}
        <div className="w-full lg:hidden flex flex-col items-center max-w-md mx-auto px-4 text-white bg-gray-800">
          <div className="relative flex justify-center mt-4 mb-16 text-center w-full h-full">
            <img
              src="/static/images/temporary_login/sp_chart.svg"
              alt="チャート"
            />
            <div
              className="flex flex-col font-bold text-center absolute"
              style={{ bottom: '-40%', left: '0%', right: '0%' }}>
              <div className="text-26">
                株式投資、投資信託を
                <br />
                まとめて管理！
              </div>
              <div className="mx-auto mt-2 px-4 py-1 text-sm bg-indigo-450 rounded-full">
                NISA・iDeCo・米国株に対応
              </div>
            </div>
          </div>

          {userType !== 'premium' ? (
            <div className="app-primary-label-block flex justify-center mt-8 text-sm">
              <div className="inline-flex items-center flex-col">
                30日間無料でプレミアムを体験
              </div>
            </div>
          ) : (
            <></>
          )}
          <button
            className={`bg-gradient-r-red w-full flex justify-center mb-4 py-2 text-lg font-bold max-w-btn-l text-white leading-9 rounded-lg cursor-pointer hover:opacity-75 ${
              userType !== 'premium' ? 'mt-1' : 'mt-8'
            }`}
            onClick={() => login()}>
            {userType === 'premium' ? 'アセプラ' : 'みんかぶ'}
            で資産管理を始める
          </button>
          {userType === 'guest' ? (
            <div
              className="mb-6 text-sm text-white text-center underline cursor-pointer"
              onClick={minkabuLogin}>
              みんかぶ会員の方はこちら
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* みんかぶアセットプランナーでできること */}
        <div className="w-full bg-white">
          <div className="flex flex-col pt-8 lg:mb-16 text-xl font-bold items-center w-full">
            <div>みんかぶアセットプランナーで</div>
            <div className="flex flex-row">
              できること
              <img
                src="/static/images/temporary_login/light.svg"
                alt="チャート"
                className=""
              />
            </div>
          </div>
          {/* PC */}
          <div className="hidden lg:flex flex-col">
            <div
              className="flex flex-row items-center justify-between mx-auto"
              style={{ width: '750px', height: '300px' }}>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible1_title.svg"
                      alt="複数の証券口座をまとめて管理"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible1.svg"
                  alt="複数の証券口座をまとめて管理"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    複数の証券口座にある株式、投資信託をまとめて管理できます。NISA、iDeCo対応。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible2_title.svg"
                      alt="株式の資産推移をグラフ化"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible2.svg"
                  alt="株式の資産推移をグラフ化"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    株式、投資信託の資産推移や損益をチャートやグラフで確認できます。
                  </div>
                </div>
              </div>
            </div>
            <div
              className="flex flex-row items-center justify-between mx-auto mt-18"
              style={{ width: '750px', height: '300px' }}>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible3_title.svg"
                      alt="取引履歴の保存・分析"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible3.svg"
                  alt="取引履歴の保存・分析"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    取引履歴を株価チャートにプロットし、過去の売買タイミングから投資の傾向がわかります。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible6_title.svg"
                      alt="配当金を支払い月ごとに管理"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible6.svg"
                  alt="配当金を支払い月ごとに管理"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    毎月もらえる配当金額を自動で計算し支払い月ごとに一覧で表示します。1年間の合計額や保有銘柄の内訳もわかります。
                  </div>
                </div>
              </div>
            </div>
            <div
              className="flex flex-row items-center justify-between mx-auto mt-18"
              style={{ width: '750px', height: '300px' }}>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible4_title.svg"
                      alt="LINEで投資の損益管理"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible4.svg"
                  alt="LINEで投資の損益管理"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    日ごと、週ごと、月ごとに投資の損益や資産変動をお知らせします。
                    <br />
                    LINE通知はアセプラだけ！
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col w-full h-full pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '350px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible5_title.svg"
                      alt="ライフプランに合わせた資産形成"
                      style={{ width: '315px', height: '70px' }}
                    />
                  </h3>
                </div>
                <img
                  src="/static/images/temporary_login/what_is_possible5.svg"
                  alt="ライフプランに合わせた資産形成"
                  className="w-full"
                />
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    老後資金など「お金を貯める目的ごと」に資産運用をシミュレーションできます。低リスク運用をAIがアドバイスします。
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center px-4 pb-8">
              {userType !== 'premium' ? (
                <div className="app-primary-label-block flex justify-center mt-6 mb-1 text-sm">
                  <div className="inline-flex items-center flex-col">
                    30日間無料でプレミアムを体験
                  </div>
                </div>
              ) : (
                <></>
              )}
              <button
                className={`bg-gradient-r-red w-full flex justify-center py-2 text-lg font-bold max-w-btn-l text-white leading-9 rounded-lg cursor-pointer hover:opacity-75 ${
                  userType === 'premium' ? 'mt-6' : ''
                }`}
                onClick={() => login()}>
                {userType === 'premium' ? 'アセプラ' : 'みんかぶ'}
                で資産管理を始める
              </button>
              {userType === 'guest' ? (
                <div
                  className="pt-6 text-sm text-blue-700 text-center underline cursor-pointer"
                  onClick={minkabuLogin}>
                  みんかぶ会員の方はこちら
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {/* sp */}
          <div className="lg:hidden flex flex-col">
            <div className="flex flex-col items-center px-2">
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible1_title.svg"
                      alt="複数の証券口座をまとめて管理"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible1.svg"
                    alt="複数の証券口座をまとめて管理"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    複数の証券口座にある株式、投資信託をまとめて管理できます。NISA、iDeCo対応。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible2_title.svg"
                      alt="株式の資産推移をグラフ化"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible2.svg"
                    alt="株式の資産推移をグラフ化"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    株式、投資信託の資産推移や損益をチャートやグラフで確認できます。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible3_title.svg"
                      alt="取引履歴の保存・分析"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible3.svg"
                    alt="取引履歴の保存・分析"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    取引履歴を株価チャートにプロットし、過去の売買タイミングから投資の傾向がわかります。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible6_title.svg"
                      alt="配当金を支払い月ごとに管理"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible6.svg"
                    alt="配当金を支払い月ごとに管理"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    毎月もらえる配当金額を自動で計算し支払い月ごとに一覧で表示します。1年間の合計額や保有銘柄の内訳もわかります。
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible4_title.svg"
                      alt="LINEで投資の損益管理"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible4.svg"
                    alt="LINEで投資の損益管理"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    日ごと、週ごと、月ごとに投資の損益や資産変動をお知らせします。
                    <br />
                    LINE通知はアセプラだけ！
                  </div>
                </div>
              </div>
              <div
                className="flex flex-col h-full mt-16 pt-6 pb-4 px-4 bg-white border border-bluegray-300 rounded-lg shadow"
                style={{ width: '360px' }}>
                <div className="relative -top-6">
                  <h3 className="flex items-center justify-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                    <img
                      src="/static/images/temporary_login/what_is_possible5_title.svg"
                      alt="ライフプランに合わせた資産形成"
                    />
                  </h3>
                </div>
                <div className="flex justify-center">
                  <img
                    src="/static/images/temporary_login/what_is_possible5.svg"
                    alt="ライフプランに合わせた資産形成"
                  />
                </div>
                <div className="flex flex-row items-baseline mt-4">
                  <div className="icon-check text-cyan-600 text-lg font-bold"></div>
                  <div className="ml-1">
                    老後資金など「お金を貯める目的ごと」に資産運用をシミュレーションできます。低リスク運用をAIがアドバイスします。
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center px-4 pb-4">
              {userType !== 'premium' ? (
                <div className="app-primary-label-block flex justify-center mt-8 text-sm">
                  <div className="inline-flex items-center flex-col">
                    30日間無料でプレミアムを体験
                  </div>
                </div>
              ) : (
                <></>
              )}
              <button
                className={`bg-gradient-r-red w-full flex justify-center py-2 text-lg font-bold max-w-btn-l text-white leading-9 rounded-lg cursor-pointer hover:opacity-75 ${
                  userType !== 'premium' ? 'mt-1' : 'mt-8'
                } ${userType !== 'guest' ? '' : 'mb-6'}`}
                onClick={() => login()}>
                {userType === 'premium' ? 'アセプラ' : 'みんかぶ'}
                で資産管理を始める
              </button>
              {userType === 'guest' ? (
                <div
                  className="mb-2 text-sm text-blue-700 text-center underline cursor-pointer"
                  onClick={minkabuLogin}>
                  みんかぶ会員の方はこちら
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* フッター */}
      <div
        id="footer"
        className="w-full bg-gray-800 py-4 px-2 text-white text-sm">
        <ul className="text-center mb-8">
          <li className="inline-block mr-4">
            <a
              href="https://minkabu.co.jp/"
              target="_blank"
              rel="noopener noreferrer">
              運営会社
            </a>
          </li>
          <li className="inline-block mr-4">
            <a
              href="https://info.minkabu.jp/tw_terms/"
              target="_blank"
              rel="noopener noreferrer">
              利用規約
            </a>
          </li>
          <li className="inline-block mr-4">
            <a
              href="https://minkabu.co.jp/privacy_policy"
              target="_blank"
              rel="noopener noreferrer">
              プライバシーポリシー
            </a>
          </li>
          {!isIosApp() && (
            <>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/economy/"
                  target="_blank"
                  rel="noopener noreferrer">
                  特定商取引表示
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/law/"
                  target="_blank"
                  rel="noopener noreferrer">
                  ご利用上の注意（関連法規）
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/ad/"
                  target="_blank"
                  rel="noopener noreferrer">
                  広告掲載・取扱商品
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://support.minkabu.jp/hc/ja"
                  target="_blank"
                  rel="noopener noreferrer">
                  ヘルプ/FAQ
                </a>
              </li>
            </>
          )}
        </ul>
        <div className="mb-4">
          <a
            href="https://minkabu.co.jp/"
            className="text-center"
            title="株式会社ミンカブ・ジ・インフォノイドコーポレートサイトへ"
            target="_blank"
            rel="noopener noreferrer">
            <img
              loading="lazy"
              src="/static/images/lp/min_infonoid_logo_white.svg"
              width="150"
              height="25"
              className="mx-auto"
              alt="ミンカブ・ジ・インフォノイド ロゴ"
            />
          </a>
          <div className="text-center">
            <span>(C) MINKABU THE INFONOID, Inc.</span>
          </div>
        </div>
      </div>
      {/* みんかぶHPフッター */}
      <nav className="w-full sticky bottom-0 left-0 z-10 bg-white shadow lg:hidden">
        <ul className="h-60p flex justify-between text-gray-dark">
          <li className="w-full">
            <a
              href="https://s.minkabu.jp"
              className="flex flex-col items-center justify-center h-full w-full">
              <img
                src="/static/images/icon/icon_home.svg"
                width="25"
                height="25"
                alt="TOP"
              />
              <p className="text-cente text-1.5xs">TOP</p>
            </a>
          </li>
          <li className="w-full">
            <a
              href="https://s.minkabu.jp/stock"
              className="flex flex-col items-center justify-center h-full w-full">
              <img
                src="/static/images/icon/icon_search.svg"
                width="25"
                height="25"
                alt="検索"
              />
              <p className="text-center text-1.5xs">検索</p>
            </a>
          </li>
          <li className="w-full">
            <a
              href="https://s.minkabu.jp/mypage/favorites"
              className="flex flex-col items-center justify-center h-full w-full">
              <img
                src="/static/images/icon/icon_heart_bold.svg"
                width="25"
                height="25"
                alt="お気に入り"
              />
              <p className="text-center text-1.5xs">お気に入り</p>
            </a>
          </li>
          <li className="w-full">
            <a
              href="/temporarylogin"
              className="flex flex-col items-center justify-center h-full w-full">
              <img
                src="/static/images/icon/icon_coin_many.svg"
                width="25"
                height="25"
                alt="資産管理"
              />
              <p className="text-center text-1.5xs">資産管理</p>
            </a>
          </li>
          <li className="w-full">
            <a
              href="https://s.minkabu.jp/mypage"
              className="flex flex-col items-center justify-center h-full w-full">
              <img
                src="/static/images/icon/icon_user.svg"
                width="25"
                height="25"
                alt="マイページ"
              />
              <p className="text-center text-1.5xs">マイページ</p>
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default TemporaryLogin;
